import { xs_languageCode } from "../..";
import { isCategoryToBeHidden } from "./isCategoryToBeHidden";
import { isSportToBeHidden } from "./isSportToBeHidden";
import { isTournamentToBeHidden } from "./isTournamentToBeHidden";

export function filterSportMenu(data) {
    const filteredSports = [];
    
    // looping sports
    for (let ks in data) {
        const sport = data[ks];
        const filteredCategories = [];
        if (!isSportToBeHidden(sport.id, sport.dsl[xs_languageCode])) {
            // looping categories
            for (let kc in sport.cts) {
                const category = sport.cts[kc];
                const filteredTournaments = [];
                if (!isCategoryToBeHidden(category.id, category.dsl[xs_languageCode])) {
                    // looping tournaments
                    for (let kt in category.tns) {
                        const tournament = category.tns[kt];
                        if (!isTournamentToBeHidden(tournament.id, tournament.dsl[xs_languageCode])) {
                            filteredTournaments.push(tournament);
                        }
                    }		
                }
                if (filteredTournaments.length > 0) {
                    category.tns = filteredTournaments;
                    filteredCategories.push(category);
                }
            }    	
        }
        if (filteredCategories.length > 0) {
            sport.cts = filteredCategories;
            filteredSports.push(sport);
        } 	
    }

    return filteredSports;
}
